var _path, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8, _linearGradient8, _path9, _linearGradient9, _path10, _linearGradient10, _path11, _linearGradient11, _path12, _linearGradient12, _path13, _linearGradient13, _path14, _linearGradient14, _path15, _linearGradient15, _path16, _linearGradient16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandNetlify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.961 11.954-.017-.007.049.049c.021 0-.032-.042-.032-.042zM23.272 12.518v.044l.094.04z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 14.937,
    x2: 14.937,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M14.933 16.276v.004c.013.006.007.001 0-.004z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 3.046,
    x2: 3.046,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m2.743 14.98 2.783-1.184.031-.009-5.023-1.049z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 6.959,
    x2: 6.959,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M6.886 12.313c.055 0 .11.003.164.008l-.006-.001a1.31 1.31 0 0 1 .351.001l-.007-.001 2.741-4.265a1.19 1.19 0 0 1-.334-.826 1.166 1.166 0 0 1 .001-.277l-.001.006-3.328-1.54-2.678 2.608 2.94 4.294c.047-.005.102-.007.157-.007z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 14.411,
    x2: 14.411,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m16.159 8.413.575-3.562-2.135-2.242-2.511 3.865v.053c.109.164.184.359.208.57l.001.006 3.505 1.487c.101-.078.22-.139.349-.176l.008-.001z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 19.685,
    x2: 19.685,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m23.327 12.605-5.933-2.537c-.166.22-.414.37-.697.407l-.005.001-.649 3.971c.186.189.303.448.304.733l3.641.765 3.338-3.321v-.019z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 20.869,
    x2: 20.869,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m20.293 8.276-2.554 1.048L24 11.988z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 3.031,
    x2: 3.031,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M5.818 13.085h.002a1.55 1.55 0 0 1 .242-.336l-.002.001-2.774-4.149L0 11.796l5.818 1.289z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 11.826,
    x2: 11.826,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M15.446 9.439a.862.862 0 0 1 .001-.161v.004l.001-.009a.052.052 0 0 0-.011-.032l-3.276-1.395c-.218.33-.587.546-1.007.546l-.041-.001h-.197l-2.71 4.191 7.24-3.143z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 4.657,
    x2: 4.657,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m3.339 15.494 1.235 1.226 1.402-2.179-.094-.095z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 17.21,
    x2: 17.21,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M16.21 15.913c-.119.152-.275.27-.454.342l-.007.003-.763 4.736 4.447-4.411s-.01.02-.021.02v-.03l-3.202-.66z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 18.288,
    x2: 18.288,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M16.974 8.507c.118.06.218.137.303.23l.001.001 2.354-1.049-2.197-2.178-.492 2.964.031.032z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 15.446,
    x2: 15.446,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M15.446 9.439v.01z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 9.105,
    x2: 9.105,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m11.899 24 1.193-1.184-5.411-7.846c-.165.078-.36.124-.564.125h-.006c-.159 0-.313-.027-.455-.076l.01.003-1.548 2.253L11.899 24z"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 12.103,
    x2: 12.103,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M8.373 13.399c.034.052.068.114.099.178l.005.011 5.892 1.215a1.05 1.05 0 0 1 .822-.524h.004l.639-3.907-.135-.115-7.326 3.142z"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 10.536,
    x2: 10.536,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M11.951 0 7.033 4.829s-.01.052 0 .063l3.245 1.383a1.236 1.236 0 0 1 .839-.283h-.002c.142.001.28.024.408.066l-.01-.003 2.532-3.96L11.951 0z"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 11.6,
    x2: 11.6,
    y1: 2.125,
    y2: 22.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c4b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529ac3"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "m14.318 15.543-.002-.007-5.964-1.226-.084.136 5.411 7.837.324-.325.921-5.689.01.007v-.028a1.048 1.048 0 0 1-.616-.705z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandNetlify);
export default __webpack_public_path__ + "static/media/brand-netlify.5eac6aa2dd5a8077d3b2f8272f6aae6d.svg";
export { ForwardRef as ReactComponent };